export default __webpack_public_path__ + "static/media/NDL_38.bc1f78c0.png";